import { OSKIconDefinition } from '../osk-icon.types';

export const oskIconAlertTriangle: OSKIconDefinition = {
  name: 'alert-triangle',
  content: '<path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" /><path d="M12 9v4" /><path d="M12 17h.01" />'
};
